// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"c38d7f01","371":"a22a52f9","726":"8c11f7b5","806":"c0e83bde"}[chunkId] + ".chunk.js";
};